import { render } from "./TemplateEdit.vue?vue&type=template&id=b6848a74&scoped=true&ts=true"
import script from "./TemplateEdit.vue?vue&type=script&lang=ts"
export * from "./TemplateEdit.vue?vue&type=script&lang=ts"

import "./TemplateEdit.vue?vue&type=style&index=0&id=b6848a74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6848a74"]])

export default __exports__